import ModalComponent from '@components/modal/Modal.component';
import { Colors } from '@constants/colors.constants';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SucceedModalProps {
  handleClose: () => void;
}

const SucceedModal = (props: SucceedModalProps) => {
  const { handleClose } = props;
  const { t } = useTranslation();

  return (
    <ModalComponent
      aria-label="over-drawer"
      handleClose={handleClose}
      contentFullWidth
      content={(
        <Stack width="100%" alignItems='center' bgcolor='#FFFFFF' spacing={3} pt="40px" pb="40px">
          <Stack alignItems={'center'} mb={'20px'} spacing={1}>
            <Typography fontWeight={700} fontSize="20px" color={Colors.black}>
              Votre réponse a bien été prise en compte !
            </Typography>
            <Typography fontWeight={400} fontSize="14px" color={Colors.black}>
              l&apos;offre est à jour avec vos dernières modifications !
            </Typography>
          </Stack>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}>
            {t('global.done')}
          </Button>
        </Stack>
      )}
    />
  );
};

export default SucceedModal;